module.exports = __webpack_public_path__ + "img/HZ-B5049.330a4496.jpg";